module.exports = __webpack_public_path__ + "static/img/banner3.920fdcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/navMobile/banner3.jpg
// module id = vqpT
// module chunks = 1